import { lazyRouteComponent as tanstackLazyRouteComponent } from '@tanstack/react-router';

import { ChunkLoadError, holdWhileReloading, isChunkLoadError } from '../reload-on-chunk-error';

export const lazyRouteComponent: typeof tanstackLazyRouteComponent = (importer, exportName) =>
  tanstackLazyRouteComponent(
    () =>
      holdWhileReloading(importer)().catch((error: unknown) => {
        throw isChunkLoadError(error) ? new ChunkLoadError(error) : error;
      }),
    exportName,
  );
